import http from '@/plugins/axios/axios';

export default class AfastamentoService {

    salvar(requisicao) {       
        return http.post('/api/afastamento/salvar', requisicao);
    }

    transferir(requisicao) {       
        return http.post('/api/afastamento/transferir', requisicao);
    }

    excluir(requisicao) {       
        return http.post('/api/afastamento/excluir', requisicao);
    }

    listarPorCrachNome(requisicao) {       
        return http.post('/api/afastamento/listar-por-nome-cracha', requisicao);
    }
    
    listar(requisicao) {       
        return http.post('/api/afastamento/listar', requisicao);
    }
    
    listarPorFuncionario(idFuncionario) {       
        return http.get('/api/afastamento/listar-historico?idf='+idFuncionario);
    }
}